"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkSig = exports.mkBytes32 = exports.mkHash = exports.mkAddress = void 0;
/**
 * Creates an eth-address compatible string with given prefix
 *
 * @param prefix  - (optional) String prefix
 * @returns 24 byte string
 */
const mkAddress = (prefix = "0x0") => {
    return prefix.padEnd(42, "0");
};
exports.mkAddress = mkAddress;
/**
 * Creates a 32-byte string
 *
 * @param prefix - (optional) String prefix
 * @returns 32 byte string with provided prefix
 */
const mkHash = (prefix = "0x") => {
    return prefix.padEnd(66, "0");
};
exports.mkHash = mkHash;
/**
 * Creates a 32-byte hex string for tests
 *
 * @param prefix - (optional) Prefix of the hex string to pad
 * @returns 32-byte hex string
 */
const mkBytes32 = (prefix = "0xa") => {
    return prefix.padEnd(66, "0");
};
exports.mkBytes32 = mkBytes32;
/**
 * Generates a string the same length as a signature
 *
 * @param prefix - (optional) Prefix of signature to create
 * @returns A string the same length as a signature
 */
const mkSig = (prefix = "0xa") => {
    return prefix.padEnd(132, "0");
};
exports.mkSig = mkSig;
//# sourceMappingURL=mk.js.map